import {Maybe, AssistantConversationMessage, SenderRole} from "../../../types/generated";
import {ProfileInformation} from "../types";

export function assistantMessageGetProfile(
    message: AssistantConversationMessage,
): Maybe<ProfileInformation> {
    const profiles = [message?.metadata?.staffProfile, message?.metadata?.ambassadorProfile];
    for (const profile of profiles) {
        if (profile) {
            return profile;
        }
    }
    return null;
}

export function assistantMessageCreate(
    id: string,
    message: string,
    sender: SenderRole,
    universityId: string,
): AssistantConversationMessage {
    return {
        __typename: "AssistantConversationMessage",
        id,
        sender,
        createdAt: new Date().toISOString(),
        message,
        universityId,
        metadata: null,
        feedback: null,
    };
}
